import {
  Component,
  OnDestroy,
  OnInit,
  HostBinding,
  HostListener,
  ViewEncapsulation,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { MediaObserver } from "@angular/flex-layout";

import * as _ from "lodash";
import { forkJoin, Observable, of, Subject } from "rxjs";
import { filter, map, switchMap, take, takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

import { AuthenticationService } from "app/auth/service";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { CoreConfigService } from "@core/services/config.service";
import { CoreMediaService } from "@core/services/media.service";

import { User } from "app/auth/models";

import { NavigationEnd, Router } from "@angular/router";
import { ThemeService } from "@core/services/theme.service";
import { DolgozokService } from "app/main/pages/torzsek/services/dolgozok.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FeladatokService } from "app/main/pages/torzsek/services/feladatok.service";
import { NotificationService } from "app/main/pages/torzsek/services/notification.service";
import { findByProp, parseJSON } from "app/main/pages/torzsek/utils";
import { OnelszamoloEgysegekService } from "app/main/pages/torzsek/services/onelszamolo-egysegek.service";
import { OnelszamoloEgyseg } from "app/main/pages/torzsek/models/torzsek";
import { MunkatarsakService } from "app/main/pages/torzsek/services/munkatarsak.service";
import { environment } from "environments/environment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FileUploadService } from "app/main/pages/torzsek/pages/munkatarsak/munkatarsak-jelenleti/munkatarsak-jelenleti.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit, OnDestroy {
  public horizontalMenu: boolean;
  public hiddenMenu: boolean;
  public route: string;

  public coreConfig: any;
  public currentSkin: string;
  public prevSkin: string;

  //Jogosultsagok
  public bizonylatok: any;
  public ajanlat: boolean;
  public kimeno: boolean;
  public szallito: boolean;
  public nyugta: boolean;
  public konyvelo: boolean;
  public currentUser$: any;
  public oek$: Observable<any>;

  isMobile = window.matchMedia('(max-width: 576px)').matches;

  files: any = [];
  fileNames: any = [];
  newFiles: any = [];

  jelszoForm: FormGroup;
  passwordTextType: boolean = false; 

  public currentUser: any;
  public selectedEgyseg: any;
  public egysegek: any[] = [];
  public raktarak: any[] = [];
  public user: any;

  public activeIndex = 1;
  public config: any;
  public jelszo_wrong = false;

  public environment = environment;

  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;
  public dolgozo: any;
  public olvasatlan: number = 0;
  public selectedCeg: any;
  public jogviszonyok: any = [];
  public selectedJogviszony: any;
  @ViewChild("avatar") avatar: ElementRef;

  @Output() refresh = new EventEmitter<void>();

  @HostBinding("class.fixed-top")
  public isFixed = false;
  public loading = false;

  @HostBinding("class.navbar-static-style-on-scroll")
  public windowScrolled = false;

  // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == "navbar-static-top" &&
      this.coreConfig.layout.type == "horizontal"
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  // Private
  private destroy$: Subject<any> = new Subject();

  public munkatars_id: any;

  /**
   * Constructor
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   * @param {CoreConfigService} _coreConfigService
   * @param {CoreSidebarService} _coreSidebarService
   * @param {CoreMediaService} _coreMediaService
   * @param {MediaObserver} _mediaObserver
   * @param {TranslateService} _translateService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _coreMediaService: CoreMediaService,
    private _coreSidebarService: CoreSidebarService,
    private _mediaObserver: MediaObserver,
    public _translateService: TranslateService,
    private _themeService: ThemeService,
    private dolgozokService: DolgozokService,
    private modalService: NgbModal,
    private feladatokService: FeladatokService,
    private notificationService: NotificationService,
    private oekService: OnelszamoloEgysegekService,
    private munkatarsakService: MunkatarsakService,
    private fb: FormBuilder,
    private uploadService: FileUploadService,
    private ngZone: NgZone
  ) {
    //dolgozokService.initData$;
    this.languageOptions = {
      en: {
        title: "English",
        flag: "us",
      },
      fr: {
        title: "French",
        flag: "fr",
      },
      de: {
        title: "German",
        flag: "de",
      },
      pt: {
        title: "Portuguese",
        flag: "pt",
      },
    };

    // Set the private defaults
    this.destroy$ = new Subject();
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  /**
   * Set the language
   *
   * @param language
   */
  setLanguage(language): void {
    // Set the selected language for the navbar on change
    this.selectedLanguage = language;

    // Use the selected language id for translations
    this._translateService.use(language);

    this._coreConfigService.setConfig(
      { app: { appLanguage: language } },
      { emitEvent: true }
    );
  }

  /**
   * Toggle Dark Skin
   */
  toggleDarkSkin() {
    // Get the current skin
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe((config) => {
        this.currentSkin = config.layout.skin;
      });

    // Toggle Dark skin with prevSkin skin
    this.prevSkin = localStorage.getItem("prevSkin");

    // Switch to light
    if (this.currentSkin === "dark") {
      this._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : "default" } },
        { emitEvent: true }
      );

      this._themeService.switchTheme("light");
    }
    // Switch to dark
    else {
      localStorage.setItem("prevSkin", this.currentSkin);
      this._coreConfigService.setConfig(
        { layout: { skin: "dark" } },
        { emitEvent: true }
      );

      this._themeService.switchTheme("dark");
    }
  }

  /**
   * Logout method
   */
  logout() {
    this._authenticationService.logout();
    this._router.navigate(["bejelentkezes"]);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // get the currentUser details from localStorage
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));


    this.currentUser$ = this._authenticationService.currentUser$;
    this.konyvelo = this.currentUser?.felhasznaloi_csoport?.id == 29;
    this.route = 'szabadsag-naptar';

    this.jelszoForm = this.fb.group({
      jelszo: [null, [Validators.required]],
      jelszo_2: [null, [Validators.required]],
    });

    this.currentUser = parseJSON(localStorage.getItem("currentUser"));
    this.user = this.currentUser;
    this.selectedCeg = this.currentUser?.oe;

    if (this.currentUser?.felhasznalok) {
      this.currentUser.felhasznalok.forEach((felhasznalo) => {
        this.jogviszonyok.push({
          ceg_id: felhasznalo.adatok.ceg_id,
          jogviszony: felhasznalo.adatok.jogviszony,
          munkatars_id: felhasznalo.adatok.id,
        });
      });
      this.jogviszonyok = this.jogviszonyok.filter(
        (jog_v) => jog_v.ceg_id == this.selectedCeg
      );

      this.selectedJogviszony = this.jogviszonyok[0];
    }

    this._router.events.subscribe((val) => {
      if(val instanceof NavigationEnd) {
        this.route = val.url.split('/').pop();
      }
    })

    // Subscribe to the config changes
    this._coreConfigService.config
      .pipe(takeUntil(this.destroy$))
      .subscribe((config) => {
        this.coreConfig = config;
        this.horizontalMenu = config.layout.type === "horizontal";
        this.hiddenMenu = config.layout.menu.hidden === true;
        this.currentSkin = config.layout.skin;

        // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
        if (this.coreConfig.layout.type === "vertical") {
          setTimeout(() => {
            if (this.coreConfig.layout.navbar.type === "fixed-top") {
              this.isFixed = true;
            }
          }, 0);
        }
      });

    // Horizontal Layout Only: Add class fixed-top to navbar below large screen
    if (this.coreConfig.layout.type == "horizontal") {
      // On every media(screen) change
      this._coreMediaService.onMediaUpdate
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          const isFixedTop = this._mediaObserver.isActive("bs-gt-xl");
          if (isFixedTop) {
            this.isFixed = false;
          } else {
            this.isFixed = true;
          }
        });
    }

    // Set the selected language from default languageOptions
    this.selectedLanguage = _.find(this.languageOptions, {
      id: this._translateService.currentLang,
    });

    // this.oek$ = this.currentUser$.pipe(
    //   switchMap((user: User) =>
    //     this.oekService.initData$.pipe(
    //       map((oek: any[]) => oek.filter((r: any) => user ? user.oek.includes(r.id) : oek))
    //     )
    //   )
    // );

    // Update user on Change
    this._authenticationService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: any) => {
        this.currentUser = user;
        console.log("user", user);

        if (this.currentUser) {
          if (!this.currentUser.munkatars) {
            // ✅ Setup oek$ with fallback to fetchData() if empty
            this.oek$ = this.oekService.initData$.pipe(
              switchMap((oek: any[]) => {
                const filtered = user
                  ? oek.filter((r: any) => user.oek.includes(r.id))
                  : [];

                if (filtered.length > 0) {
                  return of(filtered);
                } else {
                  return this.oekService
                    .fetchData()
                    .pipe(
                      map((fetched: any[]) =>
                        user
                          ? fetched.filter((r: any) => user.oek.includes(r.id))
                          : fetched
                      )
                    );
                }
              })
            );
          } else {
            this.oek$ = this.oekService.initData$.pipe(
              switchMap((oek: any[]) => {
                const user_oek = user.felhasznalok?.map((item) => item.oe);

                const filtered = user
                  ? oek.filter((r: any) => user_oek.includes(r.id))
                  : [];

                if (filtered.length > 0) {
                  return of(filtered);
                } else {
                  return this.oekService
                    .fetchData()
                    .pipe(
                      map((fetched: any[]) =>
                        user
                          ? fetched.filter((r: any) => user_oek.includes(r.id))
                          : fetched
                      )
                    );
                }
              })
            );
          }
        }

        if (this.currentUser) {
          const user = this._authenticationService.currentUserValue;

          //Jogosultságok
          const jogosultsagok = user?.jogosultsagok;

          this.bizonylatok = jogosultsagok?.find(
            (item) => item.data.torzs == "penzugyi-bizonylatok"
          );
          this.ajanlat = this.bizonylatok?.children.find(
            (item) => item.data.torzs == "ajanlat"
          );
          this.kimeno = this.bizonylatok?.children.find(
            (item) => item.data.torzs == "kimenoszamla"
          );
          this.nyugta = this.bizonylatok?.children.find(
            (item) => item.data.torzs == "nyugta"
          );
          this.szallito = this.bizonylatok?.children.find(
            (item) => item.data.torzs == "szallitolevel"
          );

          if (user) {
            this.dolgozokService
              .getById(user?.id.toString())
              .subscribe((resp) => {
                this.dolgozo = resp;
              });
          }

          this.feladatokService.initData$
            .pipe(takeUntil(this.destroy$))
            .subscribe((resp) => {
              this.olvasatlan = resp.filter(
                (item) =>
                  item.dolgozo_id == this.currentUser.id && item.statusz == -1
              ).length;
              this.notificationService.updateNotificationNumber(
                this.olvasatlan
              );
            });
        }
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }

  openSettings(): void {
    this._coreSidebarService.getSidebarRegistry("themeCustomizer").open();
  }

  openModal(content: any): void {
    this.modalService.open(content, { ariaLabelledBy: "modal-basic-title" });
  }

  openSupport(): any {
    window.open("https://www.frederik.hu", "_blank");
  }

  onSlide(event: any) {
    this.activeIndex = event.current;
  }

  updateOnOeSelect(oe: OnelszamoloEgyseg): void {
    console.log('oe', oe);
    this._authenticationService.currentUser = {
      ...this._authenticationService.currentUserValue,
      oe: oe.id,
      raktar: oe.raktarak[0] ? oe.raktarak[0].id : null,
      oeNev: oe.megnevezes,
      kulfoldi_oe: oe.kulfoldi,
    };

    let config = parseJSON(
      parseJSON(localStorage.getItem("currentUser"))?.beallitasok
    );
    this.config = config ? config : JSON.parse(localStorage.getItem("config"));
    this._coreConfigService.config = {
      ...this.config,
      user_settings: {
        oe: oe.id,
        raktar: oe.raktarak[0] ? oe.raktarak[0].id : null,
        columns: this.config.user_settings?.columns
          ? this.config.user_settings.columns
          : {},
      },
    };

    //window.location.reload();
  }

  onJelszoMod(modalRef: any): any {
    this.modalService.open(modalRef, {
      windowClass: "jelszo-modal",
      ariaLabelledBy: "modal-basic-title",
    });
  }

    /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  onJelenletiPrint(): any {
   this.munkatarsakService.jelenletiPrint.next(true); 
  }

  onUploadFiles(): void {
    console.log('newFiles', this.newFiles)
    if(this.newFiles.length > 0) {
      this.loading = true;
      this.uploadService.uploadFiles(this.newFiles, this.fileNames, 'munkatarsak', this.munkatars_id ? this.munkatars_id : this.currentUser.id).subscribe(resp => {
        this.loading = false;
        this.files = this.newFiles;
        this.newFiles = [];
        this.fileNames = [];
      })
    }
  }

  openUploadJelenleti(fajlfeltoltesModal): void {
    this.modalService.open(fajlfeltoltesModal, {
      windowClass: 'jelenleti-modal',
      ariaLabelledBy: "modal-basic-title",
    });
  }

    //Email csatolmány
    /**
     * on file drop handler
     */
    onFileDropped($event) {
      this.prepareFilesList($event);
    }
  
    /**
     * handle file from browsing
     */
    fileBrowseHandler(files) {
      this.prepareFilesList(files);
    }
  
    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number, file: any) {
      // this.uploadService
      //   .deleteFile("kimenoszamla", this.szamlaId, file.id)
      //   .subscribe((resp) => {
      //     const fileDel = findByProp(this.files, "id", resp);
      //     const deleteIndex = this.files.indexOf(fileDel);
      //     this.files.splice(deleteIndex, 1);
      //   });
    }
  
    /**
     * Delete file from newfiles list
     * @param index (File index)
     */
    deleteNewFile(index: number) {
      this.newFiles.splice(index, 1);
    }
  
    /**
     * Simulate the upload process
     */
    uploadFilesSimulator(index: number) {
      setTimeout(() => {
        if (index === this.files.length) {
          return;
        } else {
          const progressInterval = setInterval(() => {
            if (this.files[index].progress === 100) {
              clearInterval(progressInterval);
              this.uploadFilesSimulator(index + 1);
            } else {
              this.files[index].progress += 5;
            }
          }, 200);
        }
      }, 1000);
    }
  
    /**
     * Convert Files list to normal array list
     * @param files (Files List)
     */
    prepareFilesList(files: Array<any>) {
      for (const item of files) {
        item.progress = 0;
        this.newFiles.push(item);
        this.fileNames.push(this.leaveFajlKiterjesztes(item.name));
      }
  
      //this.fileDropEl.nativeElement.value = "";
      //this.uploadFilesSimulator(0);
    }
  
    /**
     * format bytes
     * @param bytes (File size in bytes)
     * @param decimals (Decimals point)
     */
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) {
        return "0 Bytes";
      }
      const k = 1024;
      const dm = decimals <= 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
  
    changeFileName(input: any, index: any): any {
      this.fileNames[index] = input;
    }
  
    onUpload(): void {

    }
  
    openFile(fajl: any): void {
      //console.log('download', fajl)
      // Basic
      window.open(
        `${environment.apiUrl}/${environment.uploadedFiles}${fajl.utvonal}`,
        "_blank"
      );
    }
  
    leaveFajlKiterjesztes(fileName: string): string {
      const kiterjesztes = fileName.split(".").pop();
  
      return fileName.replace(`.${kiterjesztes}`, "");
    }

    checkJelszo(): void {
      this.munkatarsakService.checkJelszo({ jelszo: this.jelszoForm.get('jelszo').value}).pipe(take(1)).subscribe(resp => {
        if(resp) {
          this.jelszo_wrong = false;
        } else {
          this.jelszo_wrong = true;
          this.jelszoForm.get('jelszo').patchValue(null)
        }
      }) 
    }

    onJelszoChange(modalRef: any): void {
      const user = parseJSON(localStorage.getItem('currentUser'));
      if(user?.felhasznalok) {
        let requests = []
        user.felhasznalok.map(felh => {
          const payload = {
            id: felh.id,
            jelszo: this.jelszoForm.get('jelszo').value
          };

          requests.push(this.munkatarsakService.jelszoMod(payload));
        });

        forkJoin(requests).subscribe(resp => {
          modalRef.close();
        })
      }
    }

    onJogviszonyChange(jogviszony: any): void {
      console.log('jogviszony', jogviszony);
      this.munkatars_id = jogviszony.munkatars_id;
      this.munkatarsakService.jogviszonyChange.next(jogviszony)
    }
}
